window.ActionChecklist = ActionPlan.extend({

    initialize: function(app, data, $dom, xml) {
        ActionPlan.prototype.initialize.call(this, app, data, $dom, xml);

        if(this.actionsManager.isComplete()) this.continue();
    },

    setupButtons: function() {
        var self = this;
        this.$el.find(".checkbox").change(function() {
            self.handleCheckboxClicked({target: this});
        });
    },

    handleCheckboxClicked: function(e) {
        var $item = $(e.target);
        var $action = $item.closest(".action-item");
        var id = $action.data("number");
        var action = this.actionsManager.getAction(id);
        var isChecked = $item.prop("checked");

        action.setComplete(isChecked);
        if(isChecked) this.trigger("onActionCompleted", {
            target: this,
            action: action
        });

        if(this.actionsManager.isComplete()) {
            this.$el.find(".checkbox").attr("disabled", true);
            this.continueTimeout = setTimeout(this.continue.bind(this), 1000);
        } else if(!this.isEncourageDialogShown && $item.prop("checked")) {
            this.showEncourageDialog();
        }
    },

    continue: function() {
        this.complete();
        this.app.router.next();
    },

    showEncourageDialog: function() {
        this.bootbox = new AccessibleBootbox({
            title: LanguageManager.getString('encourage_title'),
            message: LanguageManager.getString('encourage_message'),
            animate: true,
            buttons: {
                ok: {
                    label: LanguageManager.getString('keep_going'),
                    className: "btn-primary",
                    callback: function() {
                        if (this.bootbox !== undefined) {
                            this.bootbox.destroy();
                        }
                        this.bootbox = undefined;
                    }.bind(this)
                }
            }
        });
        this.bootbox.popIn();
        this.isEncourageDialogShown = true;
    },

    getContent: function(data) {
        return Handlebars.templates["actionplan/actionchecklist"](data);
    },

    getData: function($xml, language) {
        var data = ActionPlan.prototype.getData.call(this, $xml, language);

        data.limitLabel = LanguageManager.getString("limit_label");
        data.verbLabel = LanguageManager.getString("verb_label");
        data.printLabel = LanguageManager.getString("print");

        return data;
    },

    destroy: function() {
        this.actionsManager.save();
        if(this.continueTimeout) clearTimeout(this.continueTimeout);

        ActionPlan.prototype.destroy.call(this);
    }
});
